<template>
  <div class="follow-container" v-if="cid!=0">
    <!--关注的店铺用户-->
    <div class="follow-user">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px;font-family: 'SourceHanSansCN';color: #333333">我的关注</span>
          <el-button style="float: right;padding: 3px 0px;color: #333333;" type="text" @click="moreFollow(show_more)">
            {{ show_more ? '收起' : '更多' }}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
        <el-row :gutter="16">
          <el-col :span="4" v-for="(follow,index) of followData.follow" v-if="index<maxIndex"
                  style="text-align: center;">
            <div class="follow-logo" @click="authorPage(follow)">
              <el-image class="follow-img" :src="follow.user_avatar" fit="cover"/>
              <i class="follow-icon" v-if="follow.markType==1">官</i>
            </div>
            <p style="font-size: 14px;color: #999999;font-family: 'SourceHanSansCN';">{{ follow.user_name }}</p>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <!--关注收藏的文章、动态、视屏-->
    <div class="follow-article">
      <div class="info-list" v-for="article of followData.article_list" @click="details(article)"
           v-if="article.type!=3">
        <div v-if="article.photo.length<1">
          <p class="span-bold">{{ article.title }}</p>
          <p>
            <span v-if="article.is_top==1" class="span-red">置顶</span>
            <span class="span-default">{{ article.user_name }}</span>
            <span class="span-default">{{ article.time }}</span>
          </p>
        </div>
        <div v-else-if="article.photo.length<3">
          <el-row>
            <el-col :span="5">
              <el-image :src="article.photo[0]" style="height: 110px;width: 100%" fit="cover"></el-image>
              <i class="iconfont icon-bofang" v-if="article.type==2"></i>
            </el-col>
            <el-col :span="19" style="padding-left: 10px;">
              <p class="p-bold">{{ article.title }}</p>
              <p>
                <span v-if="article.is_top==1" class="span-red">置顶</span>
                <span class="span-default">{{ article.user_name }}</span>
                <span class="span-default">{{ article.time }}</span>
              </p>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <p class="span-bold">{{ article.title }}</p>
          <el-row>
            <el-col :span="5" v-for="(photo,index) of article.photo" v-if="index<3" class="imgs">
              <el-image :src="photo" style="height: 110px;width: 100%" fit="cover"></el-image>
            </el-col>
          </el-row>
          <p>
            <span v-if="article.is_top==1" class="span-red">置顶</span>
            <span class="span-default">{{ article.user_name }}</span>
            <span class="span-default">{{ article.time }}</span>
          </p>
        </div>
      </div>
      <!-- 分页 -->
      <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
    </div>
  </div>
  <div class="follow-container" v-else :style="'text-align: center;padding: 60px 0px 0px;min-height:'+min_height+'px;'">
    <p>未登录</p>
    <el-button type="danger" plain @click="login">前往登录</el-button>
  </div>
</template>
<script>
import {focusNewsArticle} from '@/api/interfaceApi'
import page from "@/components/page/pages";

export default {
  name: "followInfo",
  components: {page},
  data() {
    return {
      cid: 0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      followData: {
        article_list: [],
        follow: [],
      },
      maxIndex: 6,
      show_more: false,
      min_height: document.documentElement.clientHeight - 723,
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '2'
      }
    },
    activeTabs: {
      type: Object,
      default() {
        return {
          epidemic_url: "",
          image: "",
          is_epidemic: 0,
          is_local: 0,
          name: "推荐",
          nid: '2',
          no: 0,
        };
      }
    },
    cityList: {
      type: Object,
      default() {
        return {
          id: 500000,
          lat: 29.533155,
          level: 1,
          lng: 106.504959,
          name: "重庆",
          pid: 0,
          short_name: "重庆"
        }
      }
    }
  },
  watch: {
    activeIndex: function (val, oldVal) {
      this.tablePage.currentPage = 1;
      this.getInfo();
    }
  },
  methods: {
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInfo();
    },
    /*获取列表数据*/
    getInfo() {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      focusNewsArticle({
        page: this.tablePage.currentPage,
        cid: cid != 0 && cid != undefined ? cid : 0,
        uid: cid != 0 && cid != undefined ? cid : 0
      }).then(res => {
        if (res.code == 200) {
          window.scrollTo(0, 0);
          this.followData = res.content;
          this.tablePage.total = res.content.article_list.length;
        }
      })
    },
    /*查看关注店铺信息*/
    authorPage(row) {
      let routeData = this.$router.resolve({
        name: "userInfo",
        query: {bid: row.bid},
        path: '/userInfo/index',
      });
      window.open(routeData.href, '_blank')
    },
    /*查看详情*/
    details(row) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query: {
            id: row.id,
            type: row.type,
          },
          params: {cid: this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (row.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
    /*显示隐藏更多关注店铺用户*/
    moreFollow(status) {
      if (status) {
        this.maxIndex = 6;
        this.show_more = false;
      } else {
        this.maxIndex = this.followData.follow.length;
        this.show_more = true;
      }
    },
    /*前往登录*/
    login() {
      this.$router.replace({
        path: '/login'
      })
    }
  },
  mounted() {
    this.getInfo();
  },
  beforeMount() {
    let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.cid = cid != 0 && cid != undefined ? cid : 0
  }
}
</script>

<style scoped>
.follow-container >>> .follow-user .el-card {
  border-radius: 0px;
  border: 1px solid #F1F1F1;
  color: #333333;
}

.follow-container >>> .follow-user .el-card__header {
  padding: 10px 20px;
  border-bottom: none;
  box-sizing: border-box;
}
</style>
<style scoped lang="scss">
.follow-container {
  .follow-article {
    .info-list {
      padding: 15px 0px;

      .span-bold {
        font-size: 20px;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
      }

      .p-bold {
        font-size: 18px;
        font-weight: 100;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
        min-height: 80px;
      }

      .imgs {
        margin-right: 10px;
        margin-top: 10px;
      }

      p {
        font-size: 16px;
        margin-block-start: 10px;
        margin-block-end: 10px;

        .span-red {
          color: #FE273B;
          font-size: 14px;
          padding-right: 20px;
          font-weight: 100;
          font-family: 'SourceHanSansCN';
        }

        .span-default {
          color: #999999;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          font-weight: 100;
          padding-right: 20px;
        }
      }

      .icon-bofang {
        font-size: 30px;
        color: white;
        margin-top: 4.5%;
        position: absolute;
        margin-left: -12.2%;
      }
    }
  }
  .follow-user {
    .follow-logo {
      .follow-icon {
        position: absolute;
        font-size: 12px;
        background: #1637FF;
        color: #ffffff;
        font-style: normal;
        padding: 2px 5px;
        border-radius: 50%;
        margin-top: 40px;
        margin-left: -15px;
      }

      .follow-img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #d1d1d1;
      }
    }
  }
  .back-login {
    font-size: 16px;
    color: #333333;
  }
}
</style>